import { Model } from '@vuex-orm/core';

class Alert extends Model {
  static entity = 'alerts';

  static primaryKey = 'uuid'

  static fields() {
    return {
      uuid: this.attr(null),
      phoneNumber: this.attr(null),
      enabled: this.attr(null),
      schedule: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      fetchByGroupName(group) {
        return this.get(`groups/${group}/alerts`);
      },
      fetchByGroupAndId(group, id) {
        return this.get(`groups/${group}/alerts/${id}`);
      },
      remove(id) {
        return this.delete(`/alerts/${id}`,
          {
            delete: id,
          });
      },
      update(id, data) {
        return this.put(`alerts/${id}`, data);
      },
      create(group, data) {
        return this.post(`groups/${group}/alerts`, data);
      },
      updateUserAlerts(groupName, userId, taskIds) {
        return this.put(`groups/${groupName}/users/${userId}/alerts`, { tasks: taskIds });
      },
    },
  }
}

export default Alert;
